module.exports = __webpack_public_path__ + "static/img/3_5_1.1d7c034e.jpg";